import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { Inline, Stack } from '@/ui/line/line';

import type { RequestProjectFormFields } from './request-project-validation-schema';
import { RequestProjectFormFields as RequestProjectFormFieldsComponent } from './request-project-form-fields';

interface RequestProjectFormProps {
  onCancel: () => void;
  onSubmit: () => void;
  submitButtonLabel: string;
}

export const RequestProjectForm = ({
  onCancel,
  onSubmit,
  submitButtonLabel,
}: RequestProjectFormProps) => {
  const { t } = useTranslation('request-project');
  const {
    formState: { isSubmitting, isDirty, isValid },
  } = useFormContext<RequestProjectFormFields>();

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <Flexbox
      name="request-project-content"
      gap="24px"
      direction="column"
      fullWidth
    >
      <Stack gap="16px" margin="0 0 120px 0">
        <RequestProjectFormFieldsComponent />
      </Stack>

      <Flexbox name="request-project-form-buttons" justify="flex-end">
        <Inline gap="10px">
          <Button
            variant="underlined"
            onClick={handleCancel}
          >{t`actions.cancel`}</Button>
          <Button
            onClick={onSubmit}
            isLoading={isSubmitting}
            disabled={!isDirty || !isValid}
          >
            {submitButtonLabel}
          </Button>
        </Inline>
      </Flexbox>
    </Flexbox>
  );
};
